import { APP_URL, DYNAMICFORMS_URL, INVENTORYANDSALES_URL, MEETINGMANAGEMENT_URL } from "utils/constants";
import { ENDPOINTS, ENDPOINTSDYNAMICFORMS, ENDPOINTSINVENTORYANDSALES, ENDPOINTSMEETINGSMANAGEMENT } from "utils/endpoints";

export const SignatureBaseUrl ={
    SalesInvoices:{
        baseUrl:INVENTORYANDSALES_URL,
        endpoint:ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.signature
    },
    SalesPreInvoices:{
        baseUrl:INVENTORYANDSALES_URL,
        endpoint:ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi.signature
    },
    automation:{
        baseUrl:APP_URL,
        endpoint:ENDPOINTS.cartable.signature.browse
    },
    DynamicFormManagement:{
        baseUrl:DYNAMICFORMS_URL,
        endpoint:ENDPOINTSDYNAMICFORMS.DynamicFormApis.signature
    },
    Meetings:{
        baseUrl:MEETINGMANAGEMENT_URL , 
        endpoint:{
      browse:ENDPOINTSMEETINGSMANAGEMENT.MeetingsApis.Meetings.Signature,

      }   
    },

}